import { render, staticRenderFns } from "./IrregularModal.vue?vue&type=template&id=33025f19"
import script from "./IrregularModal.vue?vue&type=script&lang=js"
export * from "./IrregularModal.vue?vue&type=script&lang=js"
import style0 from "./IrregularModal.vue?vue&type=style&index=0&id=33025f19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports